import {
  GetUploadScreenshotUrlRequest,
  GetUploadScreenshotUrlResponse,
} from '@eigtech/meetings-types'
import { contextualGet, OmitAuthHeaders, queryOptions } from '@eigtech/ui-shared-api'
import { useUploadFile, useUploadMultipleFiles } from '@eigtech/ui-shared-files'
import { toast } from '@eigtech/ui/components/sonner'
import { meetingsBasePath, meetingsMutationKeys, meetingsQueryKeys } from './constants'
import { useInvalidateGetMeetingUploads } from './getMeeting'

// file://./../../../../meetings/service/src/commands/getUploadScreenshotUrl.ts
const getUploadScreenshotUrl = ({
  cohort,
  entityId,
  meetingId,
  startTime,
}: Omit<GetUploadScreenshotUrlRequest, 'requestActor'>) =>
  contextualGet<GetUploadScreenshotUrlResponse>(
    `${meetingsBasePath}/meeting/upload-screenshot-url/${entityId}/${meetingId}/${cohort}`,
    {
      searchParams: startTime && { startTime },
    }
  )

const uploadScreenshotQueryOptions = (request: OmitAuthHeaders<GetUploadScreenshotUrlRequest>) =>
  queryOptions({
    queryKey: meetingsQueryKeys.uploadUrl(request),
    queryFn: () => getUploadScreenshotUrl(request),
  })

export function useUploadScreenshot(request: OmitAuthHeaders<GetUploadScreenshotUrlRequest>) {
  const invalidateUploads = useInvalidateGetMeetingUploads()
  return useUploadFile(uploadScreenshotQueryOptions(request), {
    defaultMeta: { label: '', description: '', photo: '', title: '' },
    mutationKey: meetingsMutationKeys.uploadScreenshot(request),
    onSuccess() {
      toast.success('Successfully uploaded screenshot!', {
        duration: 5000,
      })
      setTimeout(
        () => invalidateUploads({ entityId: request.entityId, meetingId: request.meetingId }),
        1000
      )
    },
    onError() {
      toast.error('Could not upload screenshot.')
    },
  })
}

export function useUploadMultipleScreenshots(
  request: OmitAuthHeaders<GetUploadScreenshotUrlRequest>
) {
  return useUploadMultipleFiles(uploadScreenshotQueryOptions(request), {
    defaultMeta: { label: '', description: '', photo: '', title: '' },
  })
}
